module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/issue-02-c917400ed90650d7b937e7d1cbd5e788.png";